/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />

namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DiscountingPolicyDetailsDialog extends _Ext.ItemEditorDialog<DiscountingPolicyDetailsRow> {
        protected getFormKey() { return DiscountingPolicyDetailsForm.formKey; } 
        protected getLocalTextPrefix() { return DiscountingPolicyDetailsRow.localTextPrefix; } 
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        protected form = new DiscountingPolicyDetailsForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.Priority);
            q.setTextRightAlign(this.form.MaxDiscountPercent);
            this.form.DiscountType.changeSelect2(e => {
                var type = this.form.DiscountType.value;
                if (type == "1") {
                    q.showAndEnableField(this.form.ProductTypeId);
                    q.showAndEnableField(this.form.CategoryId);
                    q.showAndEnableField(this.form.SubCategoryId);
                    q.showAndSetRequiredField(this.form.ProductTypeId);
                    q.showAndSetRequiredField(this.form.CategoryId);
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                } else if (type == "2") {
                    q.hideField(this.form.ProductTypeId);
                    q.hideField(this.form.CategoryId);
                    q.hideField(this.form.SubCategoryId);
                    this.form.ProductTypeId.value = "0";
                    this.form.CategoryId.value = "0";
                    this.form.SubCategoryId.value = "0";
                }
            })
            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    var ItemTypeId = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.form.CategoryId.ItemTypeId = ItemTypeId;
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    if (ItemTypeId == 104) {
                        q.showAndDisableField(this.form.SubCategoryId);
                        this.form.SubCategoryId.value = "0";
                        Serenity.EditorUtils.setRequired(this.form.SubCategoryId, false);
                    }
                    else {
                        q.showAndSetRequiredField(this.form.SubCategoryId);
                        q.showAndEnableField(this.form.SubCategoryId);
                    }
                }
            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems(); 
            })

            
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.DiscountType.value != null && this.form.DiscountType.value != "") {
                var type = this.form.DiscountType.value;
                if (type == "1") {
                    q.showAndSetRequiredField(this.form.ProductTypeId);
                    q.showAndSetRequiredField(this.form.CategoryId);
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                } else if (type == "2") {
                    q.hideField(this.form.ProductTypeId);
                    q.hideField(this.form.CategoryId);
                    q.hideField(this.form.SubCategoryId);
                }
                if (this.form.ProductTypeId.value != "") {
                    var ItemTypeId = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.form.CategoryId.ItemTypeId = ItemTypeId;
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                    this.form.SubCategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    if (ItemTypeId == 104) {
                        q.showAndDisableField(this.form.SubCategoryId);
                        this.form.SubCategoryId.value = "0";
                        Serenity.EditorUtils.setRequired(this.form.SubCategoryId, false);
                    }
                    else {
                        q.showAndSetRequiredField(this.form.SubCategoryId);
                        q.showAndEnableField(this.form.SubCategoryId);
                    }
                }
            } else {
                q.hideField(this.form.ProductTypeId);
                q.hideField(this.form.CategoryId);
                q.hideField(this.form.SubCategoryId);
            }
        }
    }
}